<template>
  <v-container>
    <v-dialog
      v-model="dialogMessagerie"
      persistent
      max-width="500px"
      transition="dialog-transition"
    >
      <BaseBlock title="Messagerie" :loading="loading">
        <v-row>
          <v-col>
            <v-col v-if="dialogMessagerie">
              Demande: {{ demande.id }}
              <div v-if="demande.libelle">- {{ demande.libelle }}</div>
              <br />
              <div style="font-size: 0.8em">
                (votre message sera traité dans les meilleurs délais)
              </div>
            </v-col>
          </v-col>
          <v-col cols="12" class="mb-1">
            <v-card>
              <v-card-text v-for="message in messages" :key="message.id">
                <v-card
                  class="ma-1 pa-1"
                  :class="{
                    'green lighten-1': !message.temoinGestionnaire,
                    'red lighten-3': message.temoinGestionnaire,
                  }"
                >
                  {{ message.message }}
                </v-card>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10">
            <v-text-field
              v-model="messageInput"
              @keyup.enter="sendMessage"
              label="Ecrivez ici..."
              :disabled="noResponse"
            />
          </v-col>
          <v-col cols="2">
            <v-btn color="success" @click="sendMessage" icon
              ><v-icon>send</v-icon></v-btn
            >
          </v-col>
        </v-row>
        <v-btn color="error" @click="fermerMessagerie()"
          >fermer</v-btn
        ></BaseBlock
      >
    </v-dialog>
  </v-container>
</template>

<script>
import ApiMessagerieRepository from "@/repositories/ApiMessagerieRepository";
import BaseBlock from "@/components/base/BaseBlock";
import { mapState } from "vuex";

export default {
  components: { BaseBlock },
  props: {
    temoinGestionnaire: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      demande: null,
      dialogMessagerie: false,
      messages: [],
      messageInput: "",
      noResponse: false,
      loading: false,
      messagerie: {
        message: null,
        iddemande: null,
        sender: null,
        receiver: null,
        temoinGestionnaire: null,
        temoinMessageLu: null,
      },
    };
  },
  computed: {
    ...mapState(["user"]),
  },
  watch: {
    demande: async function () {
      if (this.dialogMessagerie) {
        this.messages = [];
        this.loading = true;
        this.messages =
          await ApiMessagerieRepository.getMessagerieMessagesByIdDemande(
            this.demande.id
          );
        await ApiMessagerieRepository.putMessagerieMessageLu(
          this.temoinGestionnaire,
          this.demande.id
        );
        this.loading = false;
      }
    },
  },
  async created() {
    if (this.dialogMessagerie) {
      console.log("aaaaaaaaaa :" + this.demande);
      this.loading = true;
      this.messages =
        await ApiMessagerieRepository.getMessagerieMessagesByIdDemande(
          this.demande.id
        );
      await ApiMessagerieRepository.putMessagerieMessageLu(
        this.temoinGestionnaire,
        this.demande.id
      );
      this.loading = false;
    }
  },
  methods: {
    async sendMessage() {
      // this.messages.push({
      //   id: this.messages.length + 1,
      //   text: this.messageInput,
      //   from: 'user'
      // })
      // this.noResponse = true;
      //       setTimeout(() => {
      //   this.messages.push({
      //     id: this.messages.length + 1,
      //     text: this.messageInput,
      //     from: 'other'
      //   });
      //   this.messageInput = '';
      //   this.noResponse = false;
      // }, 1000)
      if (this.messageInput != "") {
        this.noResponse = true;
        this.messagerie.message = this.messageInput;
        this.messagerie.iddemande = this.demande.id;
        this.messagerie.receiver = this.user.uidLdap;
        this.messagerie.temoinGestionnaire = this.temoinGestionnaire;
        this.messagerie.temoinMessageLu = false;
        console.log(this.messagerie);
        this.messageInput = "";
        await ApiMessagerieRepository.postMessagerieMessage(this.messagerie);
        this.messages.push(this.messagerie);
        this.messagerie = Object.assign({});
        this.noResponse = false;
      }
    },
    openMessagerie(demande) {
      this.dialogMessagerie = true;
      this.demande = demande;
    },
    fermerMessagerie() {
      this.messageInput = "";
      this.dialogMessagerie = false;
    },
  },
};
</script>

<style>
.green.lighten-5 {
  border-radius: 20px 20px 0 20px;
  text-align: end;
  margin-right: 1em;
}

.red.lighten-3 {
  border-radius: 20px 20px 20px 0;
  margin-left: 1em;
}
</style>
